import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import AxiosService from "../../services/AxiosHelper";

const baseURL = process.env.REACT_APP_BASEURL;

export const getDiscountList = createAsyncThunk(
    "discount/getDiscountList",
    async (businessId, { rejectWithValue }) => {
        try {
            const response = await AxiosService.AxiostRequest({
                url: baseURL + `/discount` + (businessId ? `?businessId=${businessId}` : ""),
                method: "get",
            });
            return response.data.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to fetch discounts");
        }
    }
);

export const addDiscount = createAsyncThunk(
    "discount/addDiscount",
    async (values, { rejectWithValue }) => {
        try {
            const response = await AxiosService.AxiostRequest({
                method: "post",
                url: baseURL + `/discount`,
                data: values,
            });
            return response.data.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to add discount");
        }
    }
);

export const updateDiscount = createAsyncThunk(
    "discount/updateDiscount",
    async (values, { rejectWithValue }) => {
        try {
            const response = await AxiosService.AxiostRequest({
                method: "put",
                url: baseURL + `/discount/${values.id}`,
                data: values,
            });
            return response.data.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Update failed");
        }
    }
);

export const deleteDiscount = createAsyncThunk(
    "discount/deleteDiscount",
    async (id, { rejectWithValue }) => {
        try {
            await AxiosService.AxiostRequest({
                method: "delete",
                url: baseURL + `/discount/${id}`,
            });
            return id;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to delete discount");
        }
    }
);

const discountSlice = createSlice({
    name: "discount",
    initialState: {
        discountList: [],
        loading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getDiscountList.fulfilled, (state, action) => {
            state.discountList = action.payload || [];
            state.loading = false;
        });
        builder.addCase(addDiscount.fulfilled, (state, action) => {
            state.discountList.unshift(action.payload);
            state.loading = false;
            toast.success("Discount added successfully");
        });
        builder.addCase(updateDiscount.fulfilled, (state, { payload }) => {
            state.discountList = state.discountList.map((d) =>
                d._id === payload._id ? payload : d
            );
            state.loading = false;
            toast.success("Discount updated successfully");
        });
        builder.addCase(deleteDiscount.fulfilled, (state, action) => {
            state.discountList = state.discountList.filter((d) => d._id !== action.payload);
            state.loading = false;
            toast.success("Discount deleted successfully");
        });

        // General Matchers
        builder.addMatcher(
            (action) => action.type.startsWith("discount/") && action.type.endsWith("/pending"),
            (state) => { state.loading = true; }
        );
        builder.addMatcher(
            (action) => action.type.startsWith("discount/") && (action.type.endsWith("/fulfilled") || action.type.endsWith("/rejected")),
            (state, action) => {
                state.loading = false;
                if (action.type.endsWith("/rejected")) {
                    toast.error(action.payload?.message || "Something went wrong");
                }
            }
        );
    },
});

export default discountSlice.reducer;
